import { ForgotPassword } from '../../../../interfaces/auth.interface';
import { Validation } from '../../../../interfaces/common';
import { VALIDATION_FIELD_MAPPING, APP_ERROR_MESSAGES } from '../../../../utils/appConstant';

export const validateForgotPasswordForm = (formData: ForgotPassword, fieldToValidate?: string) => {
  const validations: Validation = { validate: true, fields: [] };

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.email) {
    if (!formData.email.trim()) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.email,
        message: APP_ERROR_MESSAGES.forgotPassword.blankEmail,
      });
    }
  }

  return validations;
};
